import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { LogEvent, SetEventProperties } from '@app/core/states/event-tracking.actions';
import { PostAppConfigRequest } from '@app/features/app-content/states/app-configuration.actions';
import { AppConfigurationState } from '@app/features/app-content/states/app-configuration.state';
import { UiModule } from '@app/ui';
import { TranslateModule } from '@ngx-translate/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AppConfigurationModule } from '../app-configuration.module';

@Component({
  selector: 'rk-app-content-update',
  templateUrl: './app-content-update.component.html',
  styleUrl: './app-content-update.component.scss',
  imports: [UiModule, TranslateModule, AsyncPipe, AppConfigurationModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppContentUpdateComponent implements OnInit {
  @Select(AppConfigurationState.isLoading)
  isLoading$: Observable<boolean>;

  private readonly store = inject(Store);

  saveConfig() {
    return this.store.dispatch(new PostAppConfigRequest());
  }

  ngOnInit(): void {
    // event tracking
    this.store.dispatch(
      new SetEventProperties({
        name: 'PageUpdateContent',
        component: 'Page',
      }),
    );
    this.store.dispatch(new LogEvent('Page Viewed'));
  }
}
